var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildingCategoryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1961_6353)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1961_6353)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1961_6353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.825 13.7083V5.875H3.2417V41.125H30.6584V37.2083H22.825V33.2917H26.7417V29.375H22.825V25.4583H26.7417V21.5417H22.825V17.625H38.4917V29.375H42.4084V13.7083H22.825ZM11.075 37.2083H7.15837V33.2917H11.075V37.2083ZM11.075 29.375H7.15837V25.4583H11.075V29.375ZM11.075 21.5417H7.15837V17.625H11.075V21.5417ZM11.075 13.7083H7.15837V9.79167H11.075V13.7083ZM18.9084 37.2083H14.9917V33.2917H18.9084V37.2083ZM18.9084 29.375H14.9917V25.4583H18.9084V29.375ZM18.9084 21.5417H14.9917V17.625H18.9084V21.5417ZM18.9084 13.7083H14.9917V9.79167H18.9084V13.7083ZM46.325 37.2083V41.125H42.4084V45.0417H38.4917V41.125H34.575V37.2083H38.4917V33.2917H42.4084V37.2083H46.325ZM34.575 21.5417H30.6584V25.4583H34.575V21.5417ZM34.575 29.375H30.6584V33.2917H34.575V29.375Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1961_6353",
    x: 3.2417,
    y: 5.875,
    width: 43.0835,
    height: 41.1665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1961_6353"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1961_6353",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1961_6353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1961_6353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(-0.674805)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingCategoryIcon);
export default __webpack_public_path__ + "static/media/building-category-icon.c51030e0f68f687c972043682f51d9e7.svg";
export { ForwardRef as ReactComponent };